"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginAccountEquityReducer = void 0;
var _actionTypes = require("../actionTypes");
var initialState = {};
var marginAccountEquityReducer = exports.marginAccountEquityReducer = function marginAccountEquityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _actionTypes.RECEIVE_MARGIN_ACCOUNT_EQUITY:
      return payload;
    case _actionTypes.REQUEST_MARGIN_ACCOUNT_EQUITY:
      return initialState;
    default:
      return state;
  }
};